import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  AppButton,
  ButtonResponsiveWrapper,
  FormProvider,
  useForm,
  useResponsive,
} from '@common-fe/common-fe';

import {
  LimitedAccessVerificationFormPayload,
  LimitedAccessVerificationMethod,
} from './LimitedAccessVerification.types';
import LimitedAccessVerificationMethodForm from './LimitedAccessVerificationMethodForm';

interface Props {
  onSetVisible: (value: boolean) => void;
  onOpenMethod: (value: LimitedAccessVerificationMethod) => void;
}
const LimitedAccessVerificationSelectMethod: React.FC<Props> = ({ onSetVisible, onOpenMethod }) => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();

  const methods = useForm<LimitedAccessVerificationFormPayload>({
    defaultValues: {
      method: LimitedAccessVerificationMethod.Email,
    },
  });

  const handleSubmit = (data: LimitedAccessVerificationFormPayload) => {
    onOpenMethod(data.method);
  };
  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(handleSubmit)}>
        <LimitedAccessVerificationMethodForm />
        <ButtonResponsiveWrapper
          data-testid="limited-access-verification-select-method_buttons"
          justify="end"
          margin={{ top: isMobile ? 'spacing16' : 'spacing24' }}
        >
          {!isMobile && (
            <AppButton
              data-testid="limited-access-verification-select-method_cancel"
              buttonType="secondary"
              width="160px"
              onClick={() => onSetVisible(false)}
            >
              {t('Cancel')}
            </AppButton>
          )}

          <AppButton
            data-testid="limited-access-verification-select-method_confirm"
            fill={isMobile}
            type="submit"
            width="160px"
          >
            {t('Confirm')}
          </AppButton>
        </ButtonResponsiveWrapper>
      </form>
    </FormProvider>
  );
};
export default React.memo(LimitedAccessVerificationSelectMethod);
